<template>
  <div id="commonBackHeader" :class="{ white }">
    <div class="box">
      <div class="left">
        <img
          @click="back"
          :src="
            whiteText
              ? require('@/assets/whiteBack.png')
              : require('@/assets/returnBtn.png')
          "
          alt=""
          v-if="showReturn"
        />
      </div>
      <div class="title" :class="{ whiteText, noShowReturn: !showReturn }">
        {{ title }}
      </div>
      <img
        v-if="showMsg"
        @click="showDownloadGuide = true"
        :src="
          whiteText
            ? require('@/assets/massageIcon.png')
            : require('@/assets/massageIcon.png')
        "
        alt=""
      />
    </div>
    <common-download-guide
      v-model="showDownloadGuide"
      v-if="showDownloadGuide"
    ></common-download-guide>
  </div>
</template>

<script>
export default {
  name: 'commonBackHeader',
  props: {
    title: {
      type: String,
      default: ''
    },
    showMsg: {
      type: Boolean,
      default: true
    },
    white: {
      type: Boolean,
      default: false
    },
    showReturn: {
      type: Boolean,
      default: true
    },
    isColor: {
      type: Boolean,
      default: true
    },
    whiteText: {
      type: Boolean,
      default: false
    },
    toBack: { type: String, default: '' },
    backFn: { type: Function }
  },
  data () {
    return {
      showDownloadGuide: false
    }
  },
  methods: {
    back () {
      if (this.backFn) {
        this.backFn()
      } else if (this.toBack) {
        this.$eventTrack({
          pageName: 'LoanSuccess',
          action: 'LoanSuccess_Return'
        })
        this.$router.replace({ name: this.toBack })
      } else {
        if (this.$route.query.data && this.$route.name === 'Protocol') {
          this.$router.go('-1')
        } else {
          this.$router.go('-1')
        }
      }
    }
  }
}
</script>

<style scoped lang="less">
#commonBackHeader {
  font-weight: 600;
  font-size: 17px;
  color: #000000;
  .box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
  }
  .title {
    width: 250px;
  }
  .left {
    margin-top: 4px;
    img {
      width: 24px;
      height: 24px;
    }
  }
  img {
    width: 30px;
    height: 30px;
    margin-right: 15px;
  }
}
.white {
  background-color: #fff;
}
.whiteText {
  color: #fff;
}
.noShowReturn {
  text-align: left;
  margin-left: -18px;
  font-size: 18px;
  color: #12033a;
  font-weight: 500;
}
</style>
